<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>
                <div class="row-pointer" v-if="hwzr_encrid === ''">
                    <v-row class="pa-4">
                        <h3>Add change event</h3>
                    </v-row>
                    <v-row class="mb-6"><v-divider></v-divider></v-row>
                </div>
                <div class="row-pointer" v-else>
                    <v-row class="pa-4">
                        <h3>Update change event</h3>
                    </v-row>
                    <v-row><v-divider></v-divider></v-row>
                    <v-row dense class="pl-4 mt-6">
                        <v-col cols="4">Registered by</v-col>
                        <v-col cols="4">{{ gebr_naam }}</v-col>
                    </v-row>
                    <v-row dense class="pl-4 mt-0">
                        <v-col cols="4">Registration date/time</v-col>
                        <v-col cols="4">{{ $moment(hwzr_dt).format("DD-MM-YYYY HH:mm") }}</v-col>
                    </v-row>
                    <v-row><v-divider></v-divider></v-row>
                </div>

                <v-row dense class="pl-4 mt-8">
                    <v-col cols="4">
                        <select_status :selected_eventstatus="hwst_code" label="Status" field="hwst_code" @updateData="updateData" :disabled="isClosed"/>
                    </v-col>
                </v-row>

                <v-row dense class="pl-4 pr-6">
                    <v-col cols=12>
                        <v-form v-model="hwzr_valid">
                            <v-textarea v-model="hwzr_oms" rows="4" required label="Change event text" :rules="descriptionRules">{{ hwzr_oms }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>

                <v-card fluid flat class="mt-0 pl-4 mb-4 pr-6">
                    <howz_links :links="hwzr_urls" @updateData="updateData" />
                </v-card>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" small :disabled="!hwzr_valid" v-on:click="addUpdHwzr()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

import select_status from '@/components/huov/howz/ui/select_eventstatus.vue';
import howz_links from '@/components/huov/ui/hokl_hosm_links.vue';

export default {
    props: {
        houv_encrid: String
    },
    components: {
        select_status,
        howz_links,
    },
    data() {
        return {
            dialog: false,
            hwzr_valid: false,
            howz_encrid: '',
            hwzr_encrid: '',
            hwzr_dt: null,
            hwzr_oms: '',
            hwst_code: '',
            gebr_code: '',
            gebr_naam: '',
            hwzr_urls: [],
            descriptionRules: [
                v => !!v || "A description / value is required"
            ],
            isClosed: false
        }
    },

    methods: {
        open(howz_encrid, hwzr_encrid) {
            this.howz_encrid = howz_encrid;
            this.hwzr_encrid = hwzr_encrid;            
            this.hwzr_dt = null;
            this.hwzr_oms = '';
            this.hwst_code = 'new';
            this.gebr_code = '';
            this.gebr_naam = '';
            this.hwzr_urls = [];
            if (hwzr_encrid !== '') {
                this.getSingleHwzr();
            } else {
                this.dialog = true;
            }
            this.isClosed = false;
        },
        getSingleHwzr() {
			this.$axios.post("ares/json/ares/huov/howz/getHwzr.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getHwzr"
                },
                getHwzr: {
                    howz_encrid: this.howz_encrid,
                    hwzr_encrid: this.hwzr_encrid
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                    this.dialog = false; // do not show dialog
                } else {
                    // getHwzr returns an array, with one hwzr.
                    let hwzr = res.data.getHwzr[0];

                    this.hwzr_dt = hwzr.hwzr_dt;
                    this.hwzr_oms = hwzr.hwzr_oms;
                    this.hwst_code = hwzr.hwst_code;
                    this.gebr_code = hwzr.gebr_code;
                    this.gebr_naam = hwzr.gebr_naam;
                    this.hwzr_urls = hwzr.hwzr_urls;
                    this.isClosed = (hwzr.hwst_code === 'closed');
                    // now show dialog
                    this.dialog = true;                    
                }
            });
		},
        updateData(data) {
            // console.log('update data add_upd_hwzr', data);
            this[data.field] = data.value;
        },
        addUpdHwzr() {
            let add_upd_data = {
                howz_encrid: this.howz_encrid,
                hwzr_encrid: this.hwzr_encrid,
                gebr_code: this.gebr_code,
                hwzr_oms: this.hwzr_oms,
                hwzr_hwst: this.hwst_code,
                hwzr_urls: this.hwzr_urls
            }
            if (this.hwzr_encrid === "") {
                this.$axios.post("ares/json/ares/huov/howz/addHwzr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHwzr"
                    },
                    addHwzr: add_upd_data
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        // laten we hopen dat dit nooit gebeurt, we zetten de gebruiker vast in dit dialog met een melding of iets
                    } else {
                        this.closeDialog();                       
                    }
                }).finally();
            } else {
                this.$axios.post("ares/json/ares/huov/howz/updHwzr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHwzr"
                    },
                    updHwzr: add_upd_data
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        // laten we hopen dat dit nooit gebeurt, we zetten de gebruiker vast in dit dialog met een melding of iets
                    } else {
                        this.closeDialog();                       
                    }
                }).finally();
            }
        },
		closeDialog(){
            this.$emit("updateData", "refresh");
			this.dialog = false;
		}
    }
}
</script>

<style scoped>
    .row-pointer {
        cursor: default;
    }
</style>